import { render, staticRenderFns } from "./ButtonFavoriteHeart.vue?vue&type=template&id=6a61a374&"
import script from "./ButtonFavoriteHeart.vue?vue&type=script&lang=ts&"
export * from "./ButtonFavoriteHeart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports